export default function getResource(label) {
    const resources = {
        cancelButton: 'Annuler',
        modalTitle: 'Modifier la date',
        nextShipment: 'Prochaine expédition :',
        submitButton: 'Choisir cette date',
        submitButtonSuccess: 'La date a été modifiée'
    };

    return resources[label];
}
